module.exports = __webpack_public_path__ + "img/wx.fde9509e.jpg";